export function archivedQaReadOnly(isArchived, platform, document) {
  return Boolean(isArchived && !(platform && document?.archivedQa?.capabilities?.edit === true));
}

export function withArchivedQaPayload(payload, fallbackContext) {
  if (!payload || typeof payload !== 'object' || payload.body === undefined) return payload;
  const stringBody = typeof payload.body === 'string';
  const body = stringBody ? JSON.parse(payload.body) : payload.body;
  const context = body?.archivedQa || body?.document?.archivedQa || body?.documentContext?.archivedQa || fallbackContext;
  if (!context) return payload;
  const next = { ...body, archivedQa: context };
  return { ...payload, body: stringBody ? JSON.stringify(next) : next };
}

export function archivedQaStatus(isArchived, document, expired) {
  if (!isArchived) return '';
  if (expired) return 'Archived QA session expired. Reload before continuing; keep a copy of any unsaved changes.';
  return document?.archivedQa?.capabilities?.edit === true
    ? 'Archived submission · QA enabled'
    : 'Archived submission · Read only';
}
